import React from "react";
import { Modal } from "react-bootstrap";
import { useIntl } from "react-intl";

const ActiveDialogApi = ({ dialog, setDialog, status, handleChange }) => {
  const intl = useIntl();
  return (
    <Modal show={dialog.modal} aria-labelledby="example-modal-sizes-title-lg">
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          {dialog.status === 1
            ? intl.formatMessage({ id: "Deactivate" })
            : intl.formatMessage({ id: "Activate" })}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <span>
          {intl.formatMessage({ id: "Are.you.sure" })}{" "}
          {dialog.status === 1
            ? intl.formatMessage({ id: "deactivate" })
            : intl.formatMessage({ id: "activate" })}
          {dialog?.data?.is_default === 1
            ? " as this is a default depot for a franchise"
            : ""}
          ?
        </span>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={() => setDialog({ modal: false })}
            className="btn btn-light btn-elevate"
          >
            {intl.formatMessage({ id: "No" })}
          </button>
          <> </>
          <button
            type="button"
            onClick={() => handleChange()}
            className="btn btn-delete btn-elevate"
          >
            {intl.formatMessage({ id: "Yes" })}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ActiveDialogApi;
